import './Footer.css'

export default function Footer() {
    return (
        <div className="footer">
            <div className="contacto">
                <p>info@correofake.com</p>
                <p>987 65 43 21</p>   
            </div>
		    <div className="web-design"><a href="mailto: lem_bar@hotmail.com" >Diseño web: Mikel Barbero Les (lem_bar@hotmail.com)</a>
            </div>
        </div>
    )
}
